import { useMemo } from 'react';
import { useWatch } from 'react-hook-form';
import { IMaterializedReference } from '../../evaluate/materializeReferencePath';

/**
 * Watch di un insieme di reference materializzate, _esplicitamente_
 * solo di valori interni al form (non per il contesto)
 *
 * API Interna, da utilizzare solo in `useWatchReferences`
 */
export function useWatchFormReferences(refs: IMaterializedReference[]) {
  const paths = useMemo(() => {
    const paths = refs.map(ref => ref.absolutePath);
    // debug.log('expression.watch', 'useWatchFormReferences', { refs, paths });
    return paths;
  }, [refs]);

  return useWatch({ name: paths, disabled: paths.length === 0 }); // exact: true,
}
